import AcceptanceReviewFormEdit from 'features/AcceptanceReview/pages/Edit';
import Layout from 'layout';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function AcceptanceReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <AcceptanceReviewFormEdit />
      </Layout>
    </LayoutProvider>
  );
}
